import React from 'react';

export default class Features extends React.Component {
	render() {
		return null;
	}
}
